module.exports = __webpack_public_path__ + "static/img/02.d7a263b5.png";